import { Component } from 'react';
import { MESSAGE_LEVEL_ERROR, MESSAGE_LEVEL_SUCCESS } from "./Constants";
import { DISPLAY_MESSAGE, LOADING } from "../actions/types";

class MessageUtils extends Component {

	static dispatchSuccessMessage(dispatch, message) {
		dispatch({ type: LOADING, payload: false });
		dispatch({
			type: DISPLAY_MESSAGE,
			payload: {
				text: message,
				level: MESSAGE_LEVEL_SUCCESS
			}
		});
	}

	static dispatchErrorMessage(dispatch, message) {
		dispatch({ type: LOADING, payload: false });
		dispatch({
			type: DISPLAY_MESSAGE,
			payload: {
				text: message,
				level: MESSAGE_LEVEL_ERROR
			}
		});
	}

    static errorMessageResponse(dispatch, response, defaultMessage) {
        if(response !== undefined && response.userMessage !== undefined && response.userMessage !== null && response.userMessage !== ''){
            // if(!response.success && response.code === 400) {
             //    redirectToPageNotFound(dispatch);
             //    return;
			// }
            this.dispatchErrorMessage(dispatch, response.userMessage);
        } else {
            this.dispatchErrorMessage(dispatch, defaultMessage);
        }
    }
}

export default MessageUtils;



// WEBPACK FOOTER //
// ./src/utils/MessageUtils.js